import { h } from 'vue'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import { type LinkProps, LinkPreviewTypes } from '@canvas-builder/types/canvas'

export function adjustThemeByPreviewType(previewType: LinkPreviewTypes, data?: LinkProps | null) {
  const isOutlineOrTextLink =
    data?.preview_type === LinkPreviewTypes.OUTLINE_BUTTON || data?.preview_type === LinkPreviewTypes.TEXT_LINK
  const isSolidButton = data?.preview_type === LinkPreviewTypes.SOLID_BUTTON

  if (isOutlineOrTextLink && previewType === LinkPreviewTypes.SOLID_BUTTON)
    return {
      backgroundColor: data?.color,
      color: '#ffffff',
    }
  else if (
    isSolidButton &&
    (previewType === LinkPreviewTypes.OUTLINE_BUTTON || previewType === LinkPreviewTypes.TEXT_LINK)
  )
    return {
      backgroundColor: '',
      color: data?.background_color,
    }

  return {
    backgroundColor: data?.background_color,
    color: data?.color,
  }
}

export function getPreviewTypeOptions(t: (input: string) => string) {
  return [
    {
      icon: () => h(CIcon, { icon: 'square-t', faType: 'fas' }),
      label: t('canvasUI.canvasBuilder.link.form.previewTypes.solidButton'),
      value: LinkPreviewTypes.SOLID_BUTTON,
    },
    {
      icon: () => h(CIcon, { icon: 'square-t' }),
      label: t('canvasUI.canvasBuilder.link.form.previewTypes.outlineButton'),
      value: LinkPreviewTypes.OUTLINE_BUTTON,
    },
    {
      icon: () => h(CIcon, { icon: 't' }),
      label: t('canvasUI.canvasBuilder.link.form.previewTypes.textLink'),
      value: LinkPreviewTypes.TEXT_LINK,
    },
  ]
}
